import { render, staticRenderFns } from "./question-scale.vue?vue&type=template&id=1d936822&scoped=true&"
import script from "./question-scale.vue?vue&type=script&lang=js&"
export * from "./question-scale.vue?vue&type=script&lang=js&"
import style0 from "./question-scale.vue?vue&type=style&index=0&id=1d936822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d936822",
  null
  
)

export default component.exports